import { json } from "@sveltejs/kit";
import { exec } from "child_process";
import { promisify } from "util";
const execAsync = promisify(exec);
const POST = async () => {
  try {
    await execAsync("git pull");
    return json({ success: true });
  } catch (error) {
    console.error("Git pull error:", error);
    return json({
      error: "Failed to pull",
      message: error.message || "Unknown error"
    }, { status: 500 });
  }
};
export {
  POST
};
